import { useMemo } from 'react'
import { operations } from '~/api'
import { convertUserDetail } from '../repositories/User/helpers/ConvertUserDetail'
import { useQueryService } from './useQueryService'

export type UseInvoicesParams = operations['getInvoices']['parameters']['query']
export type UseInvoicesResponse =
  operations['getInvoices']['responses']['200']['content']['application/json']
export const useInvoices = (params?: UseInvoicesParams) =>
  useQueryService<UseInvoicesResponse>('/invoices', params)

export type UseAdminsParams = operations['getAdmins']['parameters']['query']
export type UseAdminsResponse =
  operations['getAdmins']['responses']['200']['content']['application/json']
export const useAdmins = (params?: UseAdminsParams) =>
  useQueryService<UseAdminsResponse>('/admins', params)

export type UseUsersParams = operations['getUsers']['parameters']['query']
export type UseUsersResponse =
  operations['getUsers']['responses']['200']['content']['application/json']
export const useUsers = (params?: UseUsersParams) =>
  useQueryService<UseUsersResponse>('/users', params)

export type UseUserResponse =
  operations['getUser']['responses']['200']['content']['application/json']

export const useUser = (id: number) => {
  const { data, ...rest } = useQueryService<UseUserResponse>(`/users/${id}`)
  const convertedData = useMemo(
    () => (data ? convertUserDetail(data) : undefined),
    [data]
  )
  return { data: convertedData, ...rest }
}

export type UseFavoritesParams = operations['getFavorites']['parameters']['query']
export type UseFavoritesResponse =
  operations['getFavorites']['responses']['200']['content']['application/json']
export const useFavorites = (params?: UseFavoritesParams) =>
  useQueryService<UseFavoritesResponse>('/favorites', params)

// Notifications
export type UseNotificationsParams = operations['getNotifications']['parameters']['query']
export type UseNotificationsResponse =
  operations['getNotifications']['responses']['200']['content']['application/json']
export const useNotifications = (params?: UseNotificationsParams) =>
  useQueryService<UseNotificationsResponse>('/notifications', params)
